/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".event__content[_ngcontent-%COMP%]{font-size:.789em;line-height:1.36;white-space:pre-wrap}"];
export { styles as styles };
